// 设置 rem 函数
function setRem() {
  // 设置页面根节点字体大小
  let clientWidth = document.documentElement.clientWidth
  if (clientWidth <= 600) {
    // 手机模式
    document.documentElement.style.fontSize = clientWidth / 7.5 + 'px'
  } else {
    // pc模式
    document.documentElement.style.fontSize = clientWidth / 19.2 + 'px'
  }
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.addEventListener('resize', () => {
  setRem()
})